const COMPANY_BRANDS = [
  {
    key: 'rhio',
    name: 'RHIO',
    accent: '#2563EB',
    soft: 'color-mix(in srgb, #2563EB 6%, transparent)',
    border: 'color-mix(in srgb, #2563EB 36%, var(--app-border))',
  },
  {
    key: 'ribes',
    name: 'RIBES',
    accent: '#7C3AED',
    soft: 'color-mix(in srgb, #7C3AED 6%, transparent)',
    border: 'color-mix(in srgb, #7C3AED 36%, var(--app-border))',
  },
  {
    key: 'sushinbox',
    name: 'SUSHINBOX',
    accent: '#D97706',
    soft: 'color-mix(in srgb, #D97706 6%, transparent)',
    border: 'color-mix(in srgb, #D97706 36%, var(--app-border))',
  },
];

const DEFAULT_BRAND = {
  key: 'default',
  name: 'Brand',
  accent: 'var(--brand-blue)',
  soft: 'color-mix(in srgb, var(--brand-blue) 5%, transparent)',
  border: 'color-mix(in srgb, var(--brand-blue) 28%, var(--app-border))',
};

function normalizeCompany(value) {
  return String(value || '').trim().toLocaleLowerCase('it-IT');
}

export function getCompanyBrand(...companyValues) {
  const normalizedValues = companyValues.map(normalizeCompany).filter(Boolean);
  return COMPANY_BRANDS.find((brand) => normalizedValues.some((value) => value.includes(brand.key))) || DEFAULT_BRAND;
}

export { COMPANY_BRANDS };